import { jsx as _jsx } from "react/jsx-runtime";
import Aligner from "../_private/Aligner/index.js";
import s from "./Button.module.css";
const ButtonAligner = (props) => {
    return (_jsx(Aligner, { ...props, side: props.side || props.position, className: [s.aligner, props.className] }));
};
ButtonAligner.displayName = "Button.Aligner";
export default ButtonAligner;
